export const phases = [
  {
    text: 'closed',
    style: 'is-danger',
    advanceText: 'Open Administrative Phase',
    alertText:
      'By advancing this meeting to the Administrative phase, you will be allowing users to edit their own schedules.'
  },
  {
    text: 'administrative',
    style: 'is-warning',
    advanceText: 'Open Scheduling',
    alertText:
      'By advancing this meeting to the Scheduling Open phase, you will be allowing users to schedule appointments with other organizations.'
  },
  {
    text: 'scheduling open',
    style: 'is-primary',
    advanceText: 'Close Appointments',
    alertText:
      'By advancing this meeting to the Close Appointments phase, you will no longer allow any users to schedule appointments.'
  }
];



// WEBPACK FOOTER //
// ./src/services/meeting.js